<template>
  <div>
    <common-dialog
      ref="dialog"
      width="550px"
      :show-save-button="true"
      unit="退款"
      id-key="RechargeFlowId"
      :data="data"
      form-label-width="85px"
      :save-func="api.refund"
      :get-data-func="api.info"
      @edit-opened="onEditOpened"
      close-on-saved
      :form-rules="rules"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
      @closed="reset"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB?24:12">
            <el-form-item label="退款金额" prop="RefundAmount">
              <el-input v-model="data.RefundAmount" size="mini" type="number" placeholder="请填写退款金额"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="退款原因" prop="Reason">
              <el-input v-model="data.Reason" type="textarea" rows="3" size="mini" placeholder="请填写退款原因"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RechargeFlowId: 0,
        RefundAmount: 0,
        Amount: 0,
        Reason: "",
      },
      isEdit: false,
      api: require("@/api/consume/recharge").default,
      isMB: this.$store.state.isMB,
      rules: {
        Reason: [{ required: true, message: "请填写退款原因" }],
        RefundAmount: [{ required: true, message: "请填写退款金额" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened() {
    },
    onEditOpened(row) {
      this.data.RefundAmount = row.Amount;
    },
    onBeforeSave() {
      if(!(this.data.RefundAmount > 0)) {
        this.$message.error("退款金额需大于0")
        return false;
      } else if(this.data.RefundAmount > this.data.Amount) {
        this.$message.error("退款金额不能大于充值金额")
        return false;
      }
    },
    reset() {
      
    },
  },
};
</script>
<style lang="scss">
</style>